import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingClientDocument,
  useClientSaveSigningDocumentsStepMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useClientSaveSigningDocuments = () => {
  const [handle, { loading, error: apolloError }] =
    useClientSaveSigningDocumentsStepMutation({
      refetchQueries: [OnboardingClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  return {
    loading,
    error,
    signingDocuments: useCallback(
      async (documentGroupId: string, otpCode: string) => {
        const res = await handle({
          variables: { id: documentGroupId, otpCode },
        });

        return !!res.data?.clientSaveSigningDocumentsStep;
      },
      [handle]
    ),
  };
};
